<div class="modal-cta modal-plan-details inner-modal-content">
    <div class="has-text-left modal-cta-content">
        <div class="is-flex-desktop is-aligned-top">
            <p class="title is-level-1 plan-title">
                {{ planName }}
            </p>
            @if (plan.locked === '1' && ctaLabel) {
                <div class="field plan-locked">
                    <div class="control">
                        <input
                            class="is-checkradio"
                            id="locked-{{ plan.id }}-{{ planUuid }}"
                            type="checkbox"
                            name="locked-{{ plan.id }}-{{ planUuid }}"
                            (change)="updateLockedPlans()"
                            [(ngModel)]="locked"
                        />
                        <label class="has-text-tertiary" for="locked-{{ plan.id }}-{{ planUuid }}">
                            Forfait bloqué
                        </label>
                    </div>
                </div>
            }
            @if (plan.locked === '2' && ctaLabel) {
                <p class="text plan-locked">- Forfait bloqué -</p>
            }
        </div>
        <p class="is-3 text">
            @if (finalPrice) {
                <trg-price [hasPeriod]="true" [isInlined]="true" [price]="finalPrice" [isWithoutTax]="isWithoutTax" />
            }
            @if (prices?.duration) {
                <span>
                    pendant {{ prices.duration }} mois puis
                    <trg-price
                        [hasPeriod]="true"
                        [isInlined]="true"
                        [price]="prices.forever"
                        [isWithoutTax]="isWithoutTax"
                    />
                </span>
            }
            @if (plan.duration) {
                <span>- Engagement {{ plan.duration }} mois</span>
            }
        </p>
        <p class="title is-level-3" [innerHTML]="wordingIncluded"></p>
        <div class="is-fullwidth">
            <div class="row">
                @if (plan?.data?.from_abroad) {
                    <div class="column is-12">
                        <p class="icon-and-text is-marginless is-alternate text is-aligned-center wrap-anywhere">
                            <span class="icon is-medium is-tertiary is-aligned-bottom">
                                <i class="tri-at-globe"></i>
                            </span>
                            <span>
                                {{ plan.data.from_abroad }}
                                @if (plan.data.international_call && plan?.data?.text_data) {
                                    <span
                                        class="link has-curs-pointer"
                                        (click)="showDetailsCmsBlock(SHOW_DETAILS_CMS.ABROAD_DATA)"
                                    >
                                        &nbsp;Plus de détails
                                    </span>
                                }
                            </span>
                        </p>
                    </div>
                }
                <div
                    class="columns is-multiline is-marginless has-background-grey-lighter more-details-cms-block"
                    [ngClass]="{ 'is-hidden': !showAbroadDataCms }"
                >
                    <span
                        class="icon has-curs-pointer cms-close-button"
                        (click)="hideDetailsCmsBlock(SHOW_DETAILS_CMS.ABROAD_DATA)"
                    >
                        <i class="tri-times" aria-hidden="true"></i>
                    </span>
                    <div class="column">
                        {{ plan?.data?.text_data }}
                    </div>
                </div>
            </div>
            @if (plan?.data?.double_sim) {
                <div class="column is-12">
                    <p class="icon-and-text is-marginless is-alternate text is-aligned-center">
                        <span class="icon is-medium is-tertiary is-aligned-bottom">
                            <i class="tri-sim-cards"></i>
                        </span>
                        <span>
                            Une 2ème carte SIM Internet pour utiliser votre forfait sur un second appareil (tablette,
                            montre...)
                        </span>
                    </p>
                </div>
            }
            @if (plan?.is_darwin) {
                <div class="column is-12">
                    <p class="icon-and-text is-marginless is-alternate text is-aligned-center">
                        <span class="icon is-medium is-tertiary is-aligned-bottom">
                            <i class="tri-career-committees"></i>
                        </span>
                        <span>
                            Tous les 6 mois, un nouveau palier, avec appels illimités et plus de gigas (10Go puis 20Go)
                            en France métropolitaine
                        </span>
                    </p>
                </div>
            }
            @if (plan?.data?.sms_mms) {
                <div class="column is-12">
                    <p class="icon-and-text is-marginless is-alternate text is-aligned-center">
                        <span class="icon is-medium is-tertiary is-aligned-bottom">
                            <i class="tri-phone-waiting-call"></i>
                        </span>
                        <span [innerHTML]="plan.data.sms_mms"></span>
                    </p>
                </div>
            }
            @if (plan?.data?.international_call) {
                <div class="column is-12">
                    <p class="icon-and-text is-marginless is-alternate text is-aligned-center">
                        <span class="icon is-medium is-tertiary is-aligned-bottom">
                            <i class="tri-phone-outgoing-call"></i>
                        </span>
                        <span>
                            {{ plan.data.international_call }}
                            @if (plan.data.international_call && plan?.data?.unlimited_call) {
                                <span
                                    class="link has-curs-pointer"
                                    (click)="showDetailsCmsBlock(SHOW_DETAILS_CMS.INTERNAIONAL_CALLS)"
                                >
                                    &nbsp;Plus de détails
                                </span>
                            }
                        </span>
                    </p>
                </div>
            }
            <div
                class="columns is-multiline is-marginless has-background-grey-lighter more-details-cms-block"
                [ngClass]="{ 'is-hidden': !showInternationalCallsCms }"
            >
                <span
                    class="icon has-curs-pointer cms-close-button"
                    (click)="hideDetailsCmsBlock(SHOW_DETAILS_CMS.INTERNAIONAL_CALLS)"
                >
                    <i class="tri-times" aria-hidden="true"></i>
                </span>
                <div class="column">
                    <btl-cms-block [blockId]="cmsInternationalCalls" [isBta]="true"></btl-cms-block>
                </div>
            </div>
        </div>
        <br />
        <btl-cms-block [blockId]="cmsPopin" [isBta]="true"></btl-cms-block>
    </div>
</div>
@if (ctaLabel) {
    <div class="modal-cta-actions has-background-white">
        <hr class="is-divider" />
        <div class="columns">
            <div class="column is-5">
                <button class="button is-fullwidth is-primary" (click)="addToCart()">{{ ctaLabel }}</button>
            </div>
        </div>
    </div>
}
